module.exports = __webpack_public_path__ + "components/patterns/collectionObjectImageArea/iiif_viewer_icon.svg";